import React from "react";

import { Modal } from "components/Sundry/Form/Modal";

import { ModalAdapterProps, ModalTypes } from "constants/navigation";
import { DeploymentPermissions } from "constants/permissions";

import { selectRoleCurrentDeployments } from "selectors";

import { useSomeHasPermission } from "hooks/useHasPermission";
import { useModalAdapter } from "hooks/useModalAdapter";

interface ParamsReturns {
  id: string;
  fromBusinessId: string;
  toBusinessId: string;
  labels: [];
  gstMethod: GSTMethod;
  readOnlyFields: string[];
  billingDocumentId: string;
}

export const SundryModalApapter: React.FC<ModalAdapterProps> = (
  props: ModalAdapterProps,
): React.JSX.Element => {
  const [hashParams, ignored, onClose] = useModalAdapter<ParamsReturns>(
    ModalTypes.ManualAdjustmentForm,
    props,
  );

  const {
    id,
    fromBusinessId,
    toBusinessId,
    labels,
    gstMethod,
    readOnlyFields,
    billingDocumentId,
  } = hashParams;

  const hasManualChargePermission: boolean = useSomeHasPermission(
    selectRoleCurrentDeployments,
    DeploymentPermissions.featureManualCharges,
  );

  if (!hasManualChargePermission) {
    return null;
  }

  return (
    <Modal
      id={id}
      onClose={onClose}
      fromBusinessId={fromBusinessId}
      toBusinessId={toBusinessId}
      labels={labels}
      gstMethod={gstMethod}
      readOnlyFields={readOnlyFields}
      billingDocumentId={billingDocumentId}
      note={undefined}
      totalAmountCents={undefined}
    />
  );
};
